import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment.prod";

@Injectable({
  providedIn: "root",
})
export class CorporateService {
  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {}

  GetLoadDetails(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}load-details`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetCategory(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/category`,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetProfile(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}profile`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyGST(gstin: string, token?: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + (token || sessionStorage.getItem("corporate_token") || ""),
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/gst`,
        { gstin: (gstin || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyPAN(pan: string, token?: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + (token || sessionStorage.getItem("corporate_token") || ""),
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/pan`,
        { pan: (pan || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetWorkOrder(
    token: any,
    status: any,
    page: any,
    workOrderNo: any = -1
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    let url = `${environment.base_url}${
      environment.base_uri
    }work-order?status=${status}&perPage=${10}&page=${page}`;
    if (workOrderNo && workOrderNo !== -1 && workOrderNo !== "-1") {
      url += `&workOrderNo=${workOrderNo}&search_query=${workOrderNo}`;
    }
    return this.httpClient
      .get(url, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  UpdateProfile(profileData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}profile`,
        profileData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  dashboard(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}customer/dashboard`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  TripBooking(details: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}work-order`,
        details,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  generateELR(trip_id: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/elr/${trip_id}`,
        {},
        { headers, observe: 'response' }
      )
      .pipe(map((response) => response));
  }

  updateELR(trip_id: string, payload: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/elr/${trip_id}`,
        payload,
        { headers, observe: 'response' }
      )
      .pipe(
        map((response) => response)
      );
  }


  downloadELR(token: any, tripId: any, elr_id: any): Observable<any> {
    let header = new HttpHeaders({
      // Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}pdf/generate-elr/${tripId}/${elr_id}`,
        {
          headers: header,
          observe: "response",
          responseType: "blob" as "json"   // Important for PDF download
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  workOrderView(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/view-details/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  uploadImage(file: any): Observable<any> {
    var fd = new FormData();
    fd.append("upload", file);
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}upload`, fd, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  ledgerList(
    token: any,
    fromDate: any,
    toDate: any,
    fromLocation: string,
    toLocation: string,
    selectedData: any,
    lrNo: any,
    vchlNo: any,
    salesOrder: any,
    workOrder: any,
    tripStatus: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/payment-ledger?&fromDate=${fromDate}&toDate=${toDate}&fromLocation=${fromLocation}&toLocation=${toLocation}&tripId=${selectedData}&lrNo=${lrNo}&vchlNo=${vchlNo}&salesOrderNo=${salesOrder}&workOrderNo=${workOrder}&tripStatus=${tripStatus}&perPage=${perPage}&page=${page}&download=${download}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  listDropDown(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/payment-ledger/details`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTripList(
    token: any,
    fetch_page: number,
    trip_type: string,
    tripNumber: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking?page=${fetch_page}&status=${trip_type}&search_query=${tripNumber}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getVehicleNumber(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/track?_id=${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  customerTrack(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking/truckhistory/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  tracking(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}customer/trip/${id}/track`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  latestLocation(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking/latest-location/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  accountDelete(userType: any, data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}profile/userstatus?status=${userType}&mobile=${data}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GeneratePaymentOrder(tripData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/generate/payment/order`,
        tripData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  TripPayment(paymentData: any, trip_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/payment/${trip_id}`,
        paymentData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updatePaymentResponse(token: any, payload: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/payment/response/${id}`,
        payload,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTaxdetails(): Observable<any> {
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}taxes/customer`, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  cancellationTrip(id: any, tripData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/trip_cancel/${id}`,
        tripData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  corporateLogout(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/logout`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  editPrice(id: string, pricePerTon: number, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}work-order/edit-price/${id}`,
        { price_per_ton: pricePerTon },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getBidRateRanking(id: string, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}work-order/bidRateRanking/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  closeBidding(id: string, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}work-order/close-bidding/${id}`,
        {},
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}

